import type { SecondaryMarketBlotterFetchCsvApi } from 'apiConnector/secondary-market-blotter';
import { connect } from 'react-redux';
import { blotterPanelItemReset } from 'state/blotters/blotterPanel/blotterPanel.action';
import { getSecondaryTradeBlotterPanelSelected } from 'state/blotters/blotterPanel/blotterPanel.selector';
import { getSecondaryTradeBlotterItemByQuoteId } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.selector';
import { secondaryMarketQuoteByIsinReloadRequested } from 'state/secondaryMarket/realtimeQuote/quote';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

interface OwnProps {
  api: SecondaryMarketBlotterFetchCsvApi;

  lifecyclePortalUrl: string;
}

export type SelectedItem = {
  quoteId: string;
  isin: string;
  user: string;
  fileCode?: string;
  salesCounterpart: string;
  custodian: string;
  status: string;
  currency: string;
  notional: number;
  maturityDate: Date;
  tradeDate: Date;
};

interface StateProps {
  hasSelectedItem: boolean;
  selected?: SelectedItem;
}

interface DispatchProps {
  onReset: () => void;
  onReloadQuote: (isin: string) => void;
}

export type ComponentProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => {
  const quoteId = getSecondaryTradeBlotterPanelSelected(state);
  const item = getSecondaryTradeBlotterItemByQuoteId(state, quoteId);
  if (quoteId === undefined || item === undefined) {
    return {
      hasSelectedItem: false,
    };
  }
  const {
    currency,
    isin,
    custodian,
    maturityDate,
    tradeDate,
    notional,
    selectedOnBehalfClient,
    user,
    status,
    fileCode,
  } = item;
  return {
    hasSelectedItem: true,
    selected: {
      currency,
      isin,
      custodian,
      fileCode,
      maturityDate,
      tradeDate,
      notional,
      quoteId,
      salesCounterpart: selectedOnBehalfClient,
      user,
      status,
    },
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => {
  return {
    onReset: () => {
      dispatch(blotterPanelItemReset());
    },
    onReloadQuote: (isin: string) => {
      dispatch(secondaryMarketQuoteByIsinReloadRequested(isin, 'secondaryMarketTrades'));
    },
  };
};

export const connectSecondaryMarketTradeBlotter = connect(mapStateToProps, mapDispatchToProps);
